export const SharedLabels = {
    en: {
    },

    bg: {
        close: "Затвори",
        quantity: " бр."
    }
};
